import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { DatabaseProvider } from "../contexts/DatabaseContext";

export default function AuthLayout() {

    const location = useLocation()
    const { currentUser } = useAuth();

    if(!currentUser)
        return (
            <Navigate 
                to="/login"
                state={{
                    message: "You must log in first",
                    from: location.pathname
                }} 
                replace
            />
        );

    if (!currentUser.emailVerified)
        return (
            <Navigate
                to="/verify"
                state={{
                    message: "You must verify your email first",
                    from: location.pathname
                }}
                replace
            />
        );

    return (
        <DatabaseProvider>
            <Outlet />
        </DatabaseProvider>
    );
}